const Image = ({ src, className, onLoad, onError }) => (
  <img
    src={src.startsWith('http') ? src : require(`../../public/images/${src}`)}
    className={className}
    alt=""
    onLoad={onLoad}
    onError={onError}
  />
);

export default Image;

Image.defaultProps = {
  onLoad: () => {},
  onError: () => {},
};
